<template>
  <b-card class="text-center mb-0 mt-1 position-relative">
    <div
      class="bg-competitions position-absolute top-0 left-0 w-100 h-100"
    ></div>
    <b-card-body
      class="d-flex flex-column justify-content-between position-relative zindex-1 bg-transparent p-1"
    >
      <div class="d-flex">
        <div class="w-100 d-flex justify-content-center">
          <b-skeleton width="100px" height="30px" v-if="loading" />
          <h1 class="mb-25 display-4 font-weight-bolder text-white" v-else-if="statistic">
            {{ statistic }}
          </h1>
          <h1 class="mt-2 font-weight-bolder display-4" v-else>-</h1>
        </div>
      </div>
      <div class="truncate">
        <span>{{ statisticTitle }}</span>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BImg, BSkeleton } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardBody,
    BImg,
    BSkeleton,
  },
  props: {
    statistic: {
      type: [Number, String],
    },
    statisticTitle: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
